import React from 'react';
import PropTypes from 'prop-types';
import { LegDistanceKindSelect } from './LegDistanceKindSelect';
import { LegActionCategorySelect } from './LegActionCategorySelect';
import { Badge } from '../../../shared/Badge';
import { courseBuilderConstants } from '../../../../utils/races/CourseBuilderConstants';
import { colors } from '../../../../shared/styles';
import { grey } from '../styles';

const smallVerticalSpacing = 20;
const labelStyle = {color: colors.darkGrey};

export const BuildYourOwnTab = (props) => {

  const renderSingleLegBuilder = () => {
    const legNo = 0;
    const {
      byo,
      t
    } = props;
    const leg = byo.legs[legNo] || {};
    return (
      <div>
        <div style={{display:'inline-block'}}>
          {/*<SelectField*/}
          {/*  maxHeight={150}*/}
          {/*  style={{verticalAlign:'middle', width:200, marginRight:15}}*/}
          {/*  onChange={handleRaceCatSelect}*/}
          {/*  floatingLabelText={t('Course Type')}*/}
          {/*  floatingLabelStyle={labelStyle}*/}
          {/*  value={byo.raceCat.raceCatId}*/}
          {/*  id={'course-type'}>*/}
          {/*  {buildRaceCategories()}*/}
          {/*</SelectField>*/}
          {/*<TextField*/}
          {/*  style={{verticalAlign:'middle', width:130, marginRight:15}}*/}
          {/*  value={leg.dist.toLocaleString()}*/}
          {/*  floatingLabelText={t('Distance')}*/}
          {/*  floatingLabelFixed={true}*/}
          {/*  floatingLabelStyle={labelStyle}*/}
          {/*  underlineFocusStyle={{borderColor: colors.blue}}*/}
          {/*  onChange={(e) => handleLegDistChange(e, legNo)}*/}
          {/*  id={'distance'}*/}
          {/*/>*/}
          <LegDistanceKindSelect
            value={leg.distKind}
            onChange={(e, index, value) => handleLegDistKindChange(value, legNo)}
            id={'distance-type-own-tab'}
            t={t}
          />

          <CourseName
            onChange={handleCourseNameChange}
            byo={byo}
            t={t}
          />
        </div>
      </div>
    );
  };

  const renderMultiLegBuilder = () => {
    const {
      t
    } = props;
    const {legs} = props.byo;
    const legCount = (legs || []).length;
    const renderedLegs = (legs || []).map((leg, legNo) => {
      return (
        <div key={'leg-' + legNo}>
          <Badge
            style={{
              fontSize:'10px',
              verticalAlign:'middle',
              marginTop:15,
              marginRight:15,
              backgroundColor:colors.blue,
              color:'white'
            }}
            label={(legNo + 1)}
            size={16}/>
          {/*<TextField*/}
          {/*  className='multi-course-distance'*/}
          {/*  style={{verticalAlign:'middle', width:130, marginRight:15}}*/}
          {/*  floatingLabelText={t('Distance')}*/}
          {/*  floatingLabelFixed={true}*/}
          {/*  underlineFocusStyle={{borderColor: colors.blue}}*/}
          {/*  value={leg.dist.toLocaleString()}*/}
          {/*  onChange={(e) => handleLegDistChange(e, legNo)}*/}
          {/*/>*/}
          <div style={{display:'inline-block', marginRight:15}}>
            <LegDistanceKindSelect
              value={leg.distKind}
              onChange={(e, index, value) => handleLegDistKindChange(value, legNo)}
              t={t}
            />
          </div>
          <LegActionCategorySelect
            value={leg.actionCat}
            onChange={(e, index, value) => handleActionCatChange(value, legNo)}
            t={t}
          />
        </div>
      );
    });
    return (
      <div key='setup_div'>
        <div style={{display:'inline-block'}}>
          <div>
            {/*<SelectField*/}
            {/*  maxHeight={200}*/}
            {/*  floatingLabelText={t('Course Type')}*/}
            {/*  onChange={handleRaceCatSelect}*/}
            {/*  value={byo.raceCat.raceCatId}>*/}
            {/*  {buildRaceCategories()}*/}
            {/*</SelectField>*/}
          </div>

          <div style={{display:'inline-block'}}>
            {renderedLegs}
          </div>

          <div key='legs_div' style={{marginTop:smallVerticalSpacing}}>

            {/*<FlatButton*/}
            {/*  id={'add-leg'}*/}
            {/*  backgroundColor={legCount < 7 ? colors.blue : grey}*/}
            {/*  hoverColor={colors.blue}*/}
            {/*  style={{*/}
            {/*    width:150,*/}
            {/*    color: 'white',*/}
            {/*    marginRight:5*/}
            {/*  }}*/}
            {/*  label={t('Add leg')}*/}
            {/*  primary={true}*/}
            {/*  disabled={legCount >= 7}*/}
            {/*  onTouchTap={handleAddLegClick}/>*/}
            {/*<FlatButton*/}
            {/*  id={'remove-leg'}*/}
            {/*  backgroundColor={legCount >= 2 ? colors.blue : grey}*/}
            {/*  style={{*/}
            {/*    width:150,*/}
            {/*    color:'white'*/}
            {/*  }}*/}
            {/*  hoverColor={colors.blue}*/}
            {/*  onTouchTap={handleRemoveLegClick}*/}
            {/*  label={t('Remove leg')}*/}
            {/*  disabled={legCount < 2}/>*/}
          </div>
          <CourseName
            onChange={handleCourseNameChange}
            byo={byo}/>
        </div>
      </div>
    );
  };

  const handleRaceCatSelect = (e, index, value) =>
    props.setByoRaceCategory(parseInt(value));

  const handleCourseNameChange = (e) => props.setByoCourseName(e.target.value);

  const handleLegDistChange = (e, legNo) => {
    // Remove from new value anything except digits and dot
    const dist = e.target.value.replace(/[^0-9.]+/g, '');
    // Seems that user's input is not a float
    if (isNaN(dist)) return;
    props.setByoLegDistance(legNo, dist);
  };

  const handleLegDistKindChange = (value, legNo) =>
    props.setByoLegDistanceKind(legNo, parseInt(value));

  const handleActionCatChange = (value, legNo) =>
    props.setByoLegActionCategory(legNo, parseInt(value));

  const handleAddLegClick = () => props.addByoLeg();

  const handleRemoveLegClick = () => props.removeByoLeg();

  const handleAddCourseClick = () => props.addByoCourse();

  // const buildRaceCategories = () => {
  //   const {
  //     t
  //   } = props;
  //   return (courseBuilderConstants(t).BYO_RACE_CATEGORIES).map((rc) => {
  //     return (
  //       <MenuItem key={rc.raceCatId} value={rc.raceCatId} primaryText={rc.caption} className={'course-type-items'}/>
  //     )
  //   });
  // };

  const validateSingleLeg = () => {
    const {byo: {legs}} = props;
    return legs && legs.length > 0 && legs[0].dist > 0 && legs[0].distKind > 0;
  };

  const validateMultiLeg = () => {
    const {byo: {legs}} = props;
    return (legs).every((leg) => {
      return leg.dist > 0 && leg.distKind && leg.actionCat;
    });
  };

  const validateCourse = () => {
    const {byo: {raceCat, courseName}} = props;
    const isLegBuilderValid = raceCat.isMulti ?
      validateMultiLeg() : validateSingleLeg();
    return isLegBuilderValid && courseName;
  };

  const {
    byo,
    t
  } = props;
  const legBuilder = byo.raceCat.isMulti ?
    renderMultiLegBuilder() : renderSingleLegBuilder();
  const isCourseValid = validateCourse();

  return (
    <div>
      {legBuilder}
      {/*<RaisedButton*/}
      {/*  backgroundColor={isCourseValid ? colors.blue : grey}*/}
      {/*  style={{*/}
      {/*    width:150,*/}
      {/*    marginTop:smallVerticalSpacing,*/}
      {/*    marginBottom:smallVerticalSpacing*/}
      {/*  }}*/}
      {/*  disabled={!isCourseValid}*/}
      {/*  onTouchTap={handleAddCourseClick}*/}
      {/*  label={t('Add Course')}*/}
      {/*  labelStyle={{color: 'white'}}*/}
      {/*  id={'add-course'}*/}
      {/*/>*/}
    </div>
  );
};

BuildYourOwnTab.propTypes = {
  byo: PropTypes.object.isRequired,

  setByoRaceCategory: PropTypes.func.isRequired,
  setByoCourseName: PropTypes.func.isRequired,
  addByoLeg: PropTypes.func.isRequired,
  removeByoLeg: PropTypes.func.isRequired,
  addByoCourse: PropTypes.func.isRequired,

  setByoLegDistance: PropTypes.func.isRequired,
  setByoLegDistanceKind: PropTypes.func.isRequired,
  setByoLegActionCategory: PropTypes.func.isRequired,
  t: PropTypes.func
};

const CourseName = ({byo, onChange, t}) => {
  return (
    <div style={{marginTop:5}}>
      {/*<TextField*/}
      {/*  style={{width:'100%'}}*/}
      {/*  onChange={onChange}*/}
      {/*  value={byo.courseName}*/}
      {/*  floatingLabelText={t('Course Name')}*/}
      {/*  floatingLabelFixed={true}*/}
      {/*  floatingLabelStyle={labelStyle}*/}
      {/*  underlineFocusStyle={{borderColor: colors.blue}}*/}
      {/*  id={'course-name'}*/}
      {/*/>*/}
    </div>
  );
};



/** WEBPACK FOOTER **
 ** ./components/race/create/AddCourses/BuildYourOwnTab.js
 **/